<template>
    <v-dialog v-model="exportModal" max-width="1000" persistent>
        <v-card>
            <v-card-title class="headline">{{ "Export product xlsx" | t }}</v-card-title>
            <v-card-subtitle class="subtitle-1 mb-0 pb-0">{{
                "Select which fields will be exported" | t
            }}</v-card-subtitle>
            <v-card-text>
                <div v-for="(data, type) in exportColumns" v-if="type !== 'classificators'">
                    <div class="mt-3 mb-3">{{ (type.charAt(0).toUpperCase() + type.slice(1)) | t }}</div>
                    <v-row no-gutters>
                        <v-col v-for="row in data" :key="row.label" md="4" sm="12">
                            <v-checkbox
                                hide-details
                                class="mt-0 mb-0"
                                @click.stop="toggleExportColumn({ type: type, item: row, isClassificator: false })"
                                :label="row.label | t"
                                :input-value="row.isSelected"
                            />
                        </v-col>
                    </v-row>
                </div>
                <div v-if="exportColumns && exportColumns.classificators && exportColumns.classificators.length > 0">
                    <div
                        v-for="classificator in exportColumns.classificators"
                        :key="classificator.label"
                        v-if="classificator.value !== 'allergens'"
                    >
                        <div class="mt-3 mb-3">{{ getClassificatorOrClassificatorRowTitle(classificator.label) }}</div>
                        <v-row no-gutters>
                            <v-col v-for="row in classificator.rows" :key="row.label" md="4" sm="12">
                                <v-checkbox
                                    hide-details
                                    class="mt-0"
                                    @click.stop="
                                        toggleExportColumn({
                                            type: classificator.value,
                                            item: row,
                                            isClassificator: true
                                        })
                                    "
                                    :label="getClassificatorOrClassificatorRowTitle(row.label)"
                                    :input-value="row.isSelected"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <div class="mt-3 mb-3">{{ getClassificatorOrClassificatorRowTitle(classificator.label) }}</div>
                        <v-row no-gutters>
                            <v-col md="4" sm="12">
                                <v-checkbox
                                    hide-details
                                    class="mt-0"
                                    @click.stop="
                                        toggleExportColumn({
                                            type: classificator.value,
                                            isClassificator: true
                                        })
                                    "
                                    label="Allergens"
                                    :input-value="classificator.isSelected"
                                />
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="bal-dark-gray" text @click.stop="handleSelectClick">
                    {{ "Select" | t }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="bal-dark-gray" text @click="toggleExportModal">
                    {{ "Close" | t }}
                </v-btn>

                <v-btn color="bal-green" :disabled="exportProducts.length <= 0" text @click="handleGenerateClick">
                    {{ "Generate" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import settings from "../../settings";
import { userTranslationFunctions } from "../../mixins/user-translation-functions";

export default {
    name: "product-export-modal.vue",
    mixins: [userTranslationFunctions],
    computed: {
        ...mapState("ProductStore", ["exportModal", "exportColumns", "exportProducts"]),
        ...mapGetters("ProductStore", ["exportProductIdString", "exportColumnObject"])
    },
    data() {
        return {
            pickSelect: false
        };
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        ...mapMutations("ProductStore", [
            "toggleExportModal",
            "toggleExportColumn",
            "resetExportProducts",
            "setAllExportColumnSelect"
        ]),
        ...mapActions("UserStore", ["saveUserProductXslxColumnSettings"]),
        handleGenerateClick() {
            localStorage.removeItem("exportProducts");
            this.saveUserProductXslxColumnSettings(this.exportColumns);
            let params = "?act=save-xlsx";
            params += "&productIds=" + this.exportProductIdString;
            params += "&columns=" + JSON.stringify(this.exportColumnObject);
            window.location.href = settings.api_url + "/products" + params;
        },
        handleSelectClick() {
            this.setAllExportColumnSelect(this.pickSelect);
            this.pickSelect = !this.pickSelect;
        }
    }
};
</script>

<style scoped></style>
